import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties, getId, } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validatePersistentMenuJson(persistentMenuJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // PersistentMenuJson => RichAssetPersistentMenu => RichAsset => Node
    const parentNode = persistentMenuJson?.$container?.$container
        ?.$container;
    const idField = getId(parentNode);
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: persistentMenuJson,
        allProperties: persistentMenuJson.properties,
        requiredProperties: [
            ast.TypeStaticProperty,
            ast.PersistentMenuOptionsArrayProperty,
        ],
        parentNode,
        accept,
    });
    const optionsArray = persistentMenuJson.properties.find((prop) => {
        return ast.isPersistentMenuOptionsArrayProperty(prop);
    });
    if (optionsArray?.options && optionsArray.options.length > 4) {
        accept('error', "Cannot have more than 4 items in the 'options' for persistent menu.", {
            node: persistentMenuJson,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
}
export function validatePersistentMenuOption(persistentMenuOption, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // PersistentMenuOption => PersistentMenuOptionsArrayProperty => PersistentMenuJson => RichAssetPersistentMenu => RichAsset => Node
    const parentNode = persistentMenuOption?.$container?.$container?.$container
        ?.$container?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: persistentMenuOption,
        allProperties: persistentMenuOption.properties,
        requiredProperties: [
            ast.LabelProperty,
            ast.DestProperty,
            ast.SetValueProperty,
        ],
        parentNode,
        accept,
    });
}
//# sourceMappingURL=persistent-menu.js.map